import { makeApi } from "@zodios/core";

import { endPhoningReasonsDtoSchema } from "@/types/backoffice/dto/phoning/end-phoning-reasons-dto";
import { openedInterventionDto } from "@/types/backoffice/dto/phoning/opened-intervention-dto.ts";

export const backofficePhoningApi = makeApi([
  {
    method: "get",
    path: "/opened-intervention/operator",
    response: openedInterventionDto.required(),
    alias: "getOperatorOpenedInterventions",
  },
  {
    method: "get",
    path: "/end-call/reasons",
    response: endPhoningReasonsDtoSchema,
    alias: "getPhoningEndCallReasons",
  },
]);
